import { Route } from '@angular/router';
import { MaintenanceComponent } from './maintenance.component';

export const maintenanceRoute: Route = {
  path: 'maintenance',
  data: {
    pageTitle: 'jYoguiApp.maintenance.title'
},
  component: MaintenanceComponent,
};



// WEBPACK FOOTER //
// ./src/main/webapp/app/maintenance/maintenance.route.ts